<!--
 * @Date: 2023-12-29 16:15:35
 * @Author: jm
 * @LastEditTime: 2024-01-18 11:34:33
 * @LastEditors: jm
 * @FilePath: \gameclub\src\components\Swiper.vue
 * @Description: 
-->
<template>
  <div class="swiper-container header">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, i) in dataList"
        v-if="dataList.length > 0"
        @click="clickImg(item)"
      >
        <img :src="item.gameBigImage" class="swiper-pic" />
        <div class="mask">
          <p class="name">{{ item.gamename }}</p>
        </div>
      </div>
    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "@/styles/swiper.scss";
export default {
  data() {
    return {
      activeIndex: 0,
      screenWidth: window.innerWidth,
    };
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    // 监听屏幕宽度和高度变化
    window.addEventListener("resize", this.handleResize);
  },
  watch: {
    screenWidth(newVal) {
      // 屏幕宽度发生变化时执行的操作
      location.reload()
    }
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    clickImg(data) {
      this.$emit("onClick", data);
    },
    init() {
      let _this = this;

      var swiper = new Swiper(".header", {
        // direction: 'vertical', // 垂直切换选项
        loop: true, // 循环模式选项

        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: 1,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart: function() {
            if (this.activeIndex == _this.dataList.length + 1) {
              _this.activeIndex = 1;
            } else {
              _this.activeIndex = this.activeIndex;
            }
          },
          slideChangeTransitionEnd: function() {
            this.autoplay.start(); //加这句会在轮播结束后从头开始轮播，loop就无效了
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 1000px !important;
  margin: 0px auto !important;
}
.swiper-slide swiper-slide-active {
  width: 1000px !important;
  height: 592px !important;
  border-radius: 30px !important;
  margin: 0px 40px 90px !important;
  position: relative !important;
}
.swiper-pic {
  width: 1000px;
  height: 592px;
  border-radius: 30px;
  margin: 0 auto 90px;
  display: block;
}
.mask {
  width: 1000px;
  height: 136px;
  border-radius: 0px 0px 30px 30px;
  background: rgba(0, 0, 0, 0.75);
  position: absolute;
  bottom: 90px;
  left: 0;
}
.name {
  font-size: 50px;
  font-weight: 900;
  color: #ffffff;
  line-height: 136px;
  text-indent: 36px;
}
</style>
